import React from 'react';

import { Text } from '@unimed-fesp/components';
import { Container, ErrorMessage } from './styles';

function LabelContainer({
  text,
  children,
  marginLeft,
  marginTop,
  marginBottom,
  marginRight,
  margin,
  display,
  displayText,
  handleClick = (a) => a,
  type,
  color,
  font,
  lineHeight,
  error = false,
}) {
  return (
    <Container
      display={display}
      margin={margin}
      marginRight={marginRight}
      marginBottom={marginBottom}
      marginLeft={marginLeft}
      marginTop={marginTop}
      onClick={(event) => {
        event.stopPropagation();
        handleClick(event);
      }}
      error={error}
    >
      <Text
        text={displayText === 'none' ? '' : text}
        display={displayText}
        color={color}
        marginTop={6}
        font={font}
        lineHeight={lineHeight}
      />
      {children}
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </Container>
  );
}

export default LabelContainer;
